import React from "react";
import { makeStyles } from "@material-ui/core/styles";

import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormControl from "@material-ui/core/FormControl";
import FormLabel from "@material-ui/core/FormLabel";

import TextField from "@material-ui/core/TextField";
import Accordion from "@material-ui/core/Accordion";
import AccordionSummary from "@material-ui/core/AccordionSummary";
import AccordionDetails from "@material-ui/core/AccordionDetails";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";

import OptionsManagement, {
  OptionInstrumentDetails,
} from "./OptionsManagement";
import Grid from "@material-ui/core/Grid";
import InputLabel from "@material-ui/core/InputLabel";
import { Typography } from "@material-ui/core";
import { StyledRadio } from "../../../../../utils/designComponents/StyledRadio";

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
  },
}));

const Instrument = (props) => {
  const classes = useStyles();
  let top = props.top;
  let dispatchTop = props.dispatchTop;
  const [
    tightSpreadPctEnabled,
    setTightSpreadPctEnabled,
    tightSpreadCentsEnabled,
    setTightSpreadCentsEnabled,
    optionPriceRangeEnabled,
    setOptionPriceRangeEnabled,
    tightSpreadPct,
    dispatchTightSpreadPct,
    tightSpreadCents,
    dispatchTightSpreadCents,
    optionPriceRange,
    dispatchOptionPriceRange,
    qtyRangeEnabled,
    setQtyRangeEnabled,
    dollarRangeEnabled,
    setDollarRangeEnabled,
    qtyRange,
    dispatchQtyRange,
    dollarRange,
    dispatchDollarRange,
    hugCurrentPriceEnabled,
    setHugCurrentPriceEnabled,
    hugCurrentPrice,
    dispatchHugCurrentPrice,
    setViewOptionManagementEnabled,
    expirationDates,
    setExpirationDates,
    buyOrSellOption,
    setBuyOrSellOption,
    otm,
    setOtm,
    itm,
    setItm,
    notExpiringToday,
    setNotExpiringToday,
    showExpirationDates,
    optionChoices,
    setOptionChoices,
    optionChains,
    setOptionChains,
    symbolsUsed,
    setSymbolsUsed,
    otm1Enabled,
    setOtm1Enabled,
    otm1,
    dispatchOtm1,
    itm1Enabled,
    setItm1Enabled,
    itm1,
    dispatchItm1,
  ] = props.optionsManagement;
  let entryTactics=props.entryTactics;
  return (
    <div className={classes.root}>
      <Grid item container>
        <Grid item container xs={4}>
          <FormControl component="fieldset">
            <Grid item xs={2}>
              <FormLabel>
                <Typography style={{ fontSize: 12 }}>Instrument</Typography>
              </FormLabel>
            </Grid>
            <RadioGroup
              row
              aria-label="instrument"
              name="instrument"
              value={top.instrument}
              onChange={(ev) => {
                dispatchTop({ instrument: ev.target.value });
                setViewOptionManagementEnabled(ev.target.value === "option");
                if (ev.target.value === "stock") {
                  if (symbolsUsed !== 1) {
                    setSymbolsUsed(1);
                  }
                }
                let isOption = ev.target.value === "option";
                let isQty = top.quantityBasis === "QUANTITY";
                let qtyBasisValue = 0;
                if (props.defaultQtyBasis !== undefined) {
                  if (isOption) {
                    if (isQty) {
                      qtyBasisValue = props.defaultQtyBasis["qtyOption"];
                    } else {
                      qtyBasisValue = props.defaultQtyBasis["dollarOption"];
                    }
                  } else {
                    if (isQty) {
                      qtyBasisValue = props.defaultQtyBasis["qtyStock"];
                    } else {
                      qtyBasisValue = props.defaultQtyBasis["dollarStock"];
                    }
                  }
                  props.dispatchMarketOrder({
                    quantityBasisValue: qtyBasisValue,
                  });
                  props.dispatchLimitOrder({
                    quantityBasisValue: qtyBasisValue,
                  });
                  props.dispatchCandleBreak({
                    quantityBasisValue: qtyBasisValue,
                  });
                }
              }}
            >
              <Grid item xs={5}>
                <FormControlLabel
                  value="stock"
                  control={<StyledRadio />}
                  label={
                    <Typography style={{ fontSize: 12 }}>stock</Typography>
                  }
                />
              </Grid>
              <Grid item xs={5}>
                <FormControlLabel
                  value="option"
                  control={<StyledRadio />}
                  label={
                    <Typography style={{ fontSize: 12 }}>option</Typography>
                  }
                />
              </Grid>
            </RadioGroup>
          </FormControl>
        </Grid>
        <Grid item xs={8}>
          {top.instrument === "option" ? (
            <OptionInstrumentDetails
              top={top}
              optionsManagement={[
                buyOrSellOption,
                setBuyOrSellOption,
                itm,
                setItm,
                otm,
                setOtm,
                notExpiringToday,
                setNotExpiringToday,
              ]}
            />
          ) : (
            <></>
          )}
        </Grid>
      </Grid>
      {top.instrument === "option" ? (
        <OptionsManagement
          top={top}
          optionsAvailable={props.optionsAvailable}
          dispatchTop={dispatchTop}
          optionsManagement={[
            tightSpreadPctEnabled,
            setTightSpreadPctEnabled,
            tightSpreadCentsEnabled,
            setTightSpreadCentsEnabled,
            optionPriceRangeEnabled,
            setOptionPriceRangeEnabled,
            tightSpreadPct,
            dispatchTightSpreadPct,
            tightSpreadCents,
            dispatchTightSpreadCents,
            optionPriceRange,
            dispatchOptionPriceRange,
            qtyRangeEnabled,
            setQtyRangeEnabled,
            dollarRangeEnabled,
            setDollarRangeEnabled,
            qtyRange,
            dispatchQtyRange,
            dollarRange,
            dispatchDollarRange,
            hugCurrentPriceEnabled,
            setHugCurrentPriceEnabled,
            hugCurrentPrice,
            dispatchHugCurrentPrice,
            setViewOptionManagementEnabled,
            expirationDates,
            setExpirationDates,
            setBuyOrSellOption,
            otm,
            setOtm,
            itm,
            setItm,
            notExpiringToday,
            setNotExpiringToday,
            showExpirationDates,
            optionChoices,
            setOptionChoices,
            optionChains,
            setOptionChains,
            symbolsUsed,
            setSymbolsUsed,
            otm1Enabled,
            setOtm1Enabled,
            otm1,
            dispatchOtm1,
            itm1Enabled,
            setItm1Enabled,
            itm1,
            dispatchItm1,
          ]}
          entryTactics={entryTactics}
          setOptionsAvailable={props.setOptionsAvailable}
        />
      ) : (
        <></>
      )}
    </div>
  );
};
export default Instrument;
